<template>
    <component
        :is="href ? 'a' : 'button'"
        :href="href"
        :disabled="disabled"
        class="inline-flex items-center rounded-md border-transparent text-sm font-semibold tracking-widest transition duration-150 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 shadow-md"
        :class="[
            'btn', 
            additionalClasses, 
            { 
                'block': block, 
                'auto-shine': autoShine,
                'text-center': textAlign === 'center',
                'text-left': textAlign === 'left', 
                'text-right': textAlign === 'right',
                'justify-center': textAlign === 'center',
                'justify-start': textAlign === 'left',
                'justify-end': textAlign === 'right'
            },
            disabled ? 'disabled-btn' : 'enabled-btn'
        ]"
    >
        <slot />
    </component>
</template>

<script>
export default {
    props: {
        additionalClasses: {
            type: String,
            default: ''
        },
        href: {
            type: String,
            default: null
        },
        block: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        textAlign: {
            type: String,
            default: 'center',
            validator: function (value) {
                return ['left', 'center', 'right'].indexOf(value) !== -1
            }
        }
    },
    data() {
        return {
            autoShine: false
        };
    },
    mounted() {
        this.startAutoShine();
    },
    beforeDestroy() {
        clearInterval(this.shineInterval);
    },
    methods: {
        startAutoShine() {
            this.shineInterval = setInterval(() => {
                this.autoShine = true;
                setTimeout(() => {
                    this.autoShine = false;
                }, 650); // Match the duration of the shine effect
            }, 10000); // Every 10 seconds
        }
    }
}
</script>

<style scoped>
.btn {
    text-decoration: none;
    border: 0px solid rgb(146, 175, 248);
    position: relative;
    overflow: hidden;
    padding: 0.75rem 1rem; /* Default padding */
}

/* Enabled state */
.enabled-btn {
    color: rgb(239 246 255); /* text-blue-50 */
    background: linear-gradient(to right, rgb(37 99 235), rgb(30 64 175)); /* from-blue-600 to-blue-800 */
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1);
}

.enabled-btn:hover {
    background: linear-gradient(to right, rgb(30 64 175), rgb(30 58 138)); /* hover:from-blue-800 hover:to-blue-950 */
    box-shadow: 1px 1px 25px 10px rgba(146, 167, 248, 0.4);
    transform: scale(0.98); /* active:scale-95 */
}

.enabled-btn:focus {
    background: rgb(55 65 81); /* focus:bg-gray-700 */
}

/* Disabled state */
.disabled-btn {
    color: rgb(156 163 175); /* text-gray-400 */
    background: linear-gradient(to right, rgb(229 231 235), rgb(209 213 219)); /* gray gradient */
    cursor: not-allowed;
    opacity: 0.7;
}

.disabled-btn:hover {
    background: linear-gradient(to right, rgb(229 231 235), rgb(209 213 219));
    box-shadow: none;
    transform: none;
}

.disabled-btn:focus {
    background: linear-gradient(to right, rgb(229 231 235), rgb(209 213 219));
}

/* Shine effect */
.btn:before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
        120deg,
        transparent,
        rgba(146, 148, 248, 0.4),
        transparent
    );
    transition: all 650ms;
}

.enabled-btn:hover:before,
.auto-shine:before {
    left: 100%;
}

/* Disabled shine effect */
.disabled-btn:before {
    display: none;
}

/* Block display */
.block {
    display: block;
    width: 100%;
}

/* Text alignment classes */
.text-center {
    text-align: center;
}

.text-left {
    text-align: left;
}

.text-right {
    text-align: right;
}
</style>
